// Function to translate roles
function searchVar(stringVar) {
    const upperStr = stringVar.toUpperCase();
    //For roles that are specific
    const exceptionList = [
        'WEB_ZONE_DELETE_DEVICES',
        'WEB_ZONE_UPDATE_DEVICES',
        'WEB_ZONE_CREATE_DEVICES',
        'WEB_ZONE_READ_DEVICES',
        'WEB_SUPPLIER_FORM',
        'WEB_SUPPLIER_ORDER_READ',
        'WEB_SUPPLIER_ORDER_UPDATE',
        'WEB_SUPPLIER_ORDER_DELETE',
        'WEB_SUPPLIER_ORDER_CREATE',
        'WEB_SUPPLIER_RESTRICTION_UPDATE',
        'WEB_CONTRACTOR_CONTRACT_READ',
        'WEB_CONTRACTOR_CONTRACT_UPDATE',
        'WEB_CONTRACTOR_CONTRACT_DELETE',
        'WEB_CONTRACTOR_CONTRACT_CREATE',
        'WEB_CONTRACTOR_CONTRACT_EXPORT',
        'WEB_CONTRACTOR_RESTRICTION_UPDATE',
        'WEB_VISITOR_REQUEST_READ',
        'WEB_VISITOR_INVITATION_STATUS_READ',
        'WEB_VISITOR_REQUEST_EXPORT',
        'WEB_VISITOR_INVITATION_STATUS_EXPORT',
        'WEB_VISITOR_INVITATION_STATUS_DOCUMENTATION_READ',
        'WEB_VISITOR_INVITATION_STATUS_DOCUMENTATION_MANAGE',
        'WEB_VISITOR_INVITATION_STATUS_IDENTIFY_READ',
        'WEB_VISITOR_INVITATION_STATUS_IDENTIFY_MANAGE',
        'WEB_REQUEST_ACCESS_MANAGE',
        'WEB_VISITOR_INCOMING_INVITATION_MANAGE',
        'WEB_CONTRACTOR_REQUEST_READ',
        'WEB_SUPPLIER_REQUEST_READ'
    ];

    if (exceptionList.includes(upperStr)) {
        return upperStr;
    }

    if (upperStr.includes('READ')) {
        return 'PRIVILEGE_READ';
    } else if (upperStr.includes('RECOVER')) {
        return 'PRIVILEGE_RECOVER';
    } else if (upperStr.includes('VCARD')) {
        return 'PRIVILEGE_VCARD';
    } else if (upperStr.includes('HEADERS')) {
        return 'PRIVILEGE_HEADERS';
    } else if (upperStr.includes('RESTRICTION')) {
        return 'PRIVILEGE_RESTRICTION';
    } else if (upperStr.includes('DELETE')) {
        return 'PRIVILEGE_DELETE';
    } else if (upperStr.includes('UPDATE')) {
        return 'PRIVILEGE_UPDATE';
    } else if (upperStr.includes('CREATE')) {
        return 'PRIVILEGE_CREATE';
    } else if (upperStr.includes('CANCEL')) {
        return 'PRIVILEGE_CANCEL';
    } else if (upperStr.includes('VIEW')) {
        return 'PRIVILEGE_VIEW';
    } else if (upperStr.includes('EXPORT')) {
        return 'PRIVILEGE_EXPORT';
    }else if (upperStr.includes('MANAGE_USERS')) {
        return 'WEB_PRIVILLEGE_MANAGE_USERS';
    }else if (upperStr.includes('CLONE')) {
        return 'WEB_FOODIE_MENU_CLONE';
    }else if (upperStr.includes('MANAGE_PASSWORDS')) {
        return 'WEB_EMPLOYEE_CAN_MANAGE_PASSWORDS';
    }
    return stringVar;
}

export default searchVar;
